import type { ReactNode } from "react";
import Breadcrumb from "@/components/base/Breadcrumb";

interface Crumb {
  label: string;
  path?: string;
}

interface PageHeroProps {
  eyebrow: string;
  title: string;
  desc: string;
  crumbs: Crumb[];
  children?: ReactNode;
}

export default function PageHero({ eyebrow, title, desc, crumbs, children }: PageHeroProps) {
  return (
    <section className="border-b border-background-200/70 bg-secondary-950">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <Breadcrumb items={crumbs} tone="dark" />
        <div className="mt-6 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/15 px-3 py-1 text-xs font-medium text-accent-300">
              <span className="flex h-3 w-3 items-center justify-center">
                <i className="ri-hashtag text-[11px]"></i>
              </span>
              {eyebrow}
            </span>
            <h1 className="mt-4 font-heading text-2xl font-black leading-tight text-secondary-50 md:text-4xl">
              {title}
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-secondary-100/80 md:text-base">
              {desc}
            </p>
          </div>
          {children && <div className="shrink-0">{children}</div>}
        </div>
      </div>
    </section>
  );
}